
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect,useRef,useState } from 'react';
import { _getURL } from "@/api/index";
import Redux from "@/action";
import _ from 'lodash';
import { HeaderBack } from '@/components/common/header';
import { NewsCategory, LatestNewsItem, NewsItem } from '@/components/news';
import { _getNewsCategoryData, _getNextNewsList } from '@/libraries/common';
import ScrollContainer from 'react-indiana-drag-scroll';
import { pageLimit } from '@/config/site';
import { InView } from 'react-intersection-observer';
import { LoadMore } from '@/components/common/loader';
import { _postURL } from "@/api/index";
import { pageLink } from '@/config/site';
import Link from 'next/link';
import { EmptyData } from '@/components/common/emptyData';
import { SkeletonParagraph } from '../../components/common/skeleton';
import { Skeleton } from '@mantine/core';
import { Footer } from '../../components/common/footer';
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from '../../components/body/body';
import { CustomLink } from '../../components/app/customLink';

const HottestNews = (props) => {
    const { hottestNewsList = [], t, outerScrollContainerWeight, loading = false } = props
    if(loading == true){
        return (
            <div className='hottestNews'>
                <div className='hottestNewsTitle'>
                    <p className='fontSize_16 fontWeight_bold fontColor_dark'>
                        {t('hottest_news')}
                    </p>
                </div>
                <div>
                    <ScrollContainer 
                        className='hottestNewsList'
                        vertical={false}
                        horizontal={true}
                        hideScrollbars={true}
                    >
                        <div className='hottestNewsListIniline'>
                            {
                                _.times(3, (key) => (
                                    <div key={key} className='hottestNewsItems' style={{width: outerScrollContainerWeight}}>
                                        <div className='hottestNewsItemsInner'>
                                            <div className='hottestNewsItemsLeft'>
                                                <div className='fontSize_14 hottestNewsItemsLeftTitle'>
                                                    <SkeletonParagraph row={4} isTitle={true} />
                                                </div>
                                                <div className='fontSize_12 hottestNewsItemsLeftDate displayflex justifyContentRight'>
                                                    <SkeletonParagraph isDate={true} />
                                                </div>
                                            </div>
                                            <div className='hottestNewsItems_image positionRelative'>
                                                <div className='absoluteSkeletonBox'>
                                                    <Skeleton height={'100%'} radius={'11px'}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </ScrollContainer>
                </div>
            </div>
        )
    }
    return (
        <>
            {
                !_.isEmpty(hottestNewsList) &&
                <div className='hottestNews'>
                    <div className='hottestNewsTitle'>
                        <p className='fontSize_16 fontWeight_bold fontColor_dark'>
                            {t('hottest_news')}
                        </p>
                    </div>
                    <div>
                        <ScrollContainer 
                            className='hottestNewsList'
                            vertical={false}
                            horizontal={true}
                            hideScrollbars={true}
                        >
                            <div className='hottestNewsListIniline'>
                                {
                                    _.reduce(hottestNewsList, (result, value, key) => {
                                        result.push(
                                            <CustomLink key={key} href={pageLink.news.newsMidUrl + value.link}>
                                                <div className='hottestNewsItems' style={{width: outerScrollContainerWeight}}>
                                                    <div className='hottestNewsItemsInner'>
                                                        <div className='hottestNewsItemsLeft'>
                                                            <p className='fontSize_14 hottestNewsItemsLeftTitle'>
                                                                {value.title}
                                                            </p>
                                                            <p className='fontSize_12 hottestNewsItemsLeftDate'>
                                                                {value.created_time}
                                                            </p>
                                                        </div>
                                                        <div className='hottestNewsItems_image' style={{backgroundImage: `url('${process.env.NEXT_PUBLIC_FS_URL}${value.cover_image}')`}} />
                                                    </div>
                                                </div>
                                            </CustomLink>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                        </ScrollContainer>
                    </div>
                </div>
            }
        </>
    )
}

export default function Index(props) {
    const { store, dispatch } = Redux();
    const { t, device, session } = props;
    const [loading, setLoading] = useState(true);
    const containerRef = useRef(null)
    const [outerScrollContainerWeight, setOuterScrollContainerWeight] = useState('unset')

    // news category
    const [activeNewsCategory, setActiveNewsCategory] = useState(store?.path?.newsCategory_object ?? {mainCat: 0, mainCatKey: null, subCat: [], activeCat: []})

    // news list
    const [totalRow, setTotalRow] = useState(0);
    const [newsList, setNewsList] = useState([]);
    const [offset, setOffset] = useState(0);
    const [isLoadingNewsList, setIsLoadingNewList] = useState(false)

    // hottest news
    const [hottestNewsList, setHottestNewsList] = useState([]);

    const _getHottestNews = async() =>{
        try {
            let req = {
                "type": 1,
            }
            let news = await _postURL("/api/news/getHottest", {...req});
            if(!_.isEmpty(news.data.data)) {
                setHottestNewsList(news.data.data);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
        // get scrollcontainer width - side padding
        if(containerRef?.current){
            setOuterScrollContainerWeight(containerRef?.current?.clientWidth - 40)
        }
        const fetchData = async() => {
            try{
                if(store?.path?.dataNewsCategory?.[t('lang')] == undefined ? true : false){
                    await _getNewsCategoryData(dispatch, t('lang'), store)
                }
                await _getHottestNews()
            } catch(error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    },[])

    useEffect(()=>{
        // get from chatgpt to prevent leak memory
        let isMounted = true;
        const fetchData = async () => {
            if (activeNewsCategory?.activeCat !== undefined) {
                try {
                    if (isMounted) {
                        setIsLoadingNewList(true)
                        setNewsList([]);
                        setTotalRow(0);
                        setOffset(0);
                        await _getNextNewsList(
                            {
                                offset: 0,
                                limit: 10,
                                activeNewsCategory: activeNewsCategory.activeCat
                            },
                            setNewsList,
                            setTotalRow,
                        );
                        setIsLoadingNewList(false)
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        };
        fetchData();
        return () => {
            isMounted = false;
            // Cancel any ongoing asynchronous tasks if needed
        };
    },[activeNewsCategory?.activeCat])

    const _handleLoadMore = async(inView, entry) => {
        if(inView == true && isLoadingNewsList == false){
            setIsLoadingNewList(true)
            await _getNextNewsList({offset: offset + pageLimit, limit: pageLimit, activeNewsCategory: activeNewsCategory?.activeCat}, setNewsList, setTotalRow)
            setOffset((prev)=>prev + pageLimit)
            setIsLoadingNewList(false)
        }
    }

    return (
        <>
            <AllMeta
                title={t('newsPage_meta_title')}
                description={t('newsPage_meta_description')}
                keyword={t('newsPage_meta_keyword')}
            />
            <Head><title>{t('newsPage_title')}</title></Head>
            <MyBody
                t={t}
                containerRef={containerRef}
                headerComponent={
                    <HeaderBack t={t} />
                }
            >
                <NewsCategory 
                    data={store?.path?.dataNewsCategory?.[t('lang')]}
                    activeNewsCategory={activeNewsCategory}
                    setActiveNewsCategory={setActiveNewsCategory}
                    subCatOpen={true}
                    t={t}
                    loading={store?.path?.dataNewsCategory?.[t('lang')] == undefined ? true : false}
                />
                <HottestNews 
                    hottestNewsList={hottestNewsList} 
                    t={t} 
                    outerScrollContainerWeight={outerScrollContainerWeight} 
                    loading={loading} 
                />
                <LatestNewsItem data={newsList?.[0]} loading={loading} type={newsList?.[0]?.type} />
                <NewsItem data={newsList?.[1]} loading={loading} type={newsList?.[1]?.type} />
                <NewsItem data={newsList?.[2]} loading={loading} type={newsList?.[2]?.type} />
                <NewsItem data={newsList?.[3]} loading={loading} type={newsList?.[3]?.type} />
                {
                        _.reduce(newsList, (result, value, key) => {
                            key > 3 ? 
                            result.push(
                                <NewsItem key={key} data={value} type={value?.type} />
                            )
                            :
                            null
                            return result
                        },[])
                }
                {
                    _.isEmpty(newsList) &&
                    <EmptyData t={t} isLoading={isLoadingNewsList} />
                }
                {
                    totalRow > (offset + pageLimit) &&
                    <InView as="div" onChange={_handleLoadMore}>
                        <LoadMore t={t} />
                    </InView>
                }
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('newsPage_meta_title')}
    //             description={t('newsPage_meta_description')}
    //             keyword={t('newsPage_meta_keyword')}
    //         />
    //         <Head><title>{t('newsPage_title')}</title></Head>
    //         <div className='bodyContainer'>
    //             <div ref={containerRef} className='contentContainer'>
    //                 <HeaderBack t={t} />
    //                 <NewsCategory 
    //                     data={store?.path?.dataNewsCategory?.[t('lang')]}
    //                     activeNewsCategory={activeNewsCategory}
    //                     setActiveNewsCategory={setActiveNewsCategory}
    //                     subCatOpen={true}
    //                     t={t}
    //                     loading={store?.path?.dataNewsCategory?.[t('lang')] == undefined ? true : false}
    //                 />
    //                 <HottestNews 
    //                     hottestNewsList={hottestNewsList} 
    //                     t={t} 
    //                     outerScrollContainerWeight={outerScrollContainerWeight} 
    //                     loading={loading} 
    //                 />
    //                 <LatestNewsItem data={newsList?.[0]} loading={loading} type={newsList?.[0]?.type} />
    //                 <NewsItem data={newsList?.[1]} loading={loading} type={newsList?.[1]?.type} />
    //                 <NewsItem data={newsList?.[2]} loading={loading} type={newsList?.[2]?.type} />
    //                 <NewsItem data={newsList?.[3]} loading={loading} type={newsList?.[3]?.type} />
    //                 {
    //                         _.reduce(newsList, (result, value, key) => {
    //                             key > 3 ? 
    //                             result.push(
    //                                 <NewsItem key={key} data={value} type={value?.type} />
    //                             )
    //                             :
    //                             null
    //                             return result
    //                         },[])
    //                 }
    //                 {
    //                     _.isEmpty(newsList) &&
    //                     <EmptyData t={t} isLoading={isLoadingNewsList} />
    //                 }
    //                 {
    //                     totalRow > (offset + pageLimit) &&
    //                     <InView as="div" onChange={_handleLoadMore}>
    //                         <LoadMore t={t} />
    //                     </InView>
    //                 }
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </>
    // )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
        ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}